import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
function namespacePlugin(namespace) {
  return element => {
    var _element$root;
    const skipNamespaceSelector = "#skip-namespace";
    if (element.type === "rule" && Array.isArray(element.props) && ((_element$root = element.root) === null || _element$root === void 0 ? void 0 : _element$root.type) !== "@keyframes") {
      element.props = element.props.map(value => {
        if (value.startsWith(skipNamespaceSelector)) return value.replace("".concat(skipNamespaceSelector, " "), "").replace(skipNamespaceSelector, "");
        if (value.startsWith(namespace) || value.startsWith("&")) return value;
        return "".concat(namespace, " ").concat(value);
      });
    }
  };
}
function createEmotionCache(_ref) {
  let {
    key,
    rtl,
    namespace
  } = _ref;
  const namespaceKey = key === "header" ? "#platform_modernisation_".concat(key) : "#epm_".concat(key);
  return createCache({
    key,
    stylisPlugins: [prefixer, namespace && namespacePlugin(namespaceKey), rtl && rtlPlugin].filter(Boolean)
  });
}
export { createEmotionCache };